/**
 * useCommunitySearch Hook
 * React Query infinite query for the Explore Communities section
 */

import { useInfiniteQuery } from "@tanstack/react-query"
import * as connectService from "../services/connect.service"
import type { ConnectFilters } from "../types/connect.types"

export function useCommunitySearch(filters: ConnectFilters) {
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage, error } =
    useInfiniteQuery({
      queryKey: ["connect-communities", filters],
      queryFn: ({ pageParam = 1 }) =>
        connectService.searchCommunities({
          page: pageParam as number,
          limit: 6,
          search: filters.search || undefined,
          sortBy: filters.sortBy,
          show: filters.show,
          city: filters.city,
          state: filters.state,
          country: filters.country,
        }),
      initialPageParam: 1,
      getNextPageParam: lastPage => {
        if (lastPage.pagination.hasNextPage) {
          return lastPage.pagination.page + 1
        }
        return undefined
      },
      staleTime: 5 * 60 * 1000,
      refetchOnWindowFocus: false,
    })

  const communities = data?.pages.flatMap(page => page.communities ?? []) ?? []

  return {
    communities,
    isLoading,
    isFetchingNextPage,
    hasNextPage: hasNextPage ?? false,
    fetchNextPage,
    error,
  }
}
